import {call, put, select} from "redux-saga/effects";
import {api} from "../../../api/api";
import {CardStateOption, searchActions, SearchItem} from "../search.slice";
import {CardState} from "../../../common";
import {RootState} from "../../../store/rootReducer";

interface SearchState {
    text: string;
    tag: string;
    cardState: CardStateOption;
    markedOnly: boolean;
}

function selectSearchState(state: RootState): SearchState {
    return {
        text: state.search.text,
        tag: state.search.tag,
        cardState: state.search.cardState,
        markedOnly: state.search.markedOnly,
    };
}

function isSameQuery(left: SearchState, right: SearchState): boolean {
    return left.text === right.text && left.tag === right.tag && left.cardState === right.cardState
        && left.markedOnly === right.markedOnly;
}

export function* searchChangedSaga(): Generator<unknown, void, unknown> {
    const requested = (yield select(selectSearchState)) as SearchState;

    const state: number | undefined = requested.cardState === CardStateOption.All
        ? undefined
        : CardState[requested.cardState] as unknown as number;

    try {
        const searchResults: SearchItem[] = (yield call(api.search, {
            text: requested.text,
            tag: requested.tag,
            state,
            marked: requested.markedOnly,
        })) as SearchItem[];

        const current = (yield select(selectSearchState)) as SearchState;
        if (!isSameQuery(requested, current)) {
            return;
        }

        yield put(searchActions.put(searchResults));
    } catch {
        // Error in search saga
    }
}
